import { Organization } from '../types'

const organizations: { [name: string]: Organization } = {
  gameStart: {
    name: 'GameStart LLC',
    link: 'https://www.gamestartschool.org/'
  },
  gameChanger: {
    name: 'GameChanger Charity',
    link: 'https://www.gamechangercharity.org/'
  },
  tri: {
    name: 'Theraputic Riding, Inc',
    link: 'http://www.therapeuticridinginc.org/'
  },
  healthDesign: {
    name: 'Theraputic Riding, Inc',
    link: 'https://www.healthdesignby.us/'
  },
  dayDream: {
    name: 'Google DayDream',
    link: 'https://vr.google.com/daydream/'
  },
  sumerian: {
    name: 'Amazon Sumerian',
    link: 'https://aws.amazon.com/sumerian/'
  },
  mott: {
    name: 'C.S. Mott Childrens Hospital',
    link: 'http://bit.ly/GS_MottProgram'
  },
  twitch: {
    name: 'Twitch',
    link: 'http://twitch.tv'
  },
  saagara: {
    name: 'Saagara',
    link: 'http://www.saagara.com'
  },
  magicLeap: {
    name: 'Magic Leap',
    link: 'http://www.magicleap.com'
  }
}
export default organizations
